module.exports = __webpack_public_path__ + "assets/profile_black.0d21d3ab.svg";